import PopperTooltip from 'shared/ui/Popper/PopperTooltip';
import { logError } from 'shared/functions';

export const renderEntitySection = (...args) => {
  const [rowsOptions, parent, onClick, entity, entitiesType] = args;

  return (sectionsKey) => {
    if (!rowsOptions) {
      throw new Error('Rows options should be present!');
    } else if (!onClick) {
      throw new Error('Method onClick should be present!');
    } else if (!entity) {
      throw new Error('Entity should be present!');
    }
    const section = rowsOptions[sectionsKey];
    if (!section) {
      logError(sectionsKey);
      throw new Error(`Section ${sectionsKey} not found!`);
    } else if (section.showCondition && !section.showCondition(entity, parent)) {
      return null;
    }

    const handleClick = () => onClick(sectionsKey, entity, parent.props);

    const { CustomPreviewRenderer } = section;

    if (CustomPreviewRenderer) {
      return (
        <CustomPreviewRenderer
          key={sectionsKey}
          id={sectionsKey}
          entity={entity}
          active={sectionsKey === parent.state.section}
          onClick={handleClick}
        />
      );
    }

    // section.render should be deleted in time
    const Renderer = section.renderPreview || section.render;

    return (
      <div
        key={sectionsKey}
        id={sectionsKey}
        className={`media panel-menu-item ${sectionsKey === parent.state.section ? 'active' : ''}`}
        onClick={handleClick}
      >
        <div className="media-left">
          <i className={section.icon} />
        </div>
        <div className="media-body">
          {typeof section.getSectionCaption === 'function' ? (
            <div className="media-left-caption">
              {section.getSectionCaption(sectionsKey, <h4>{section.label}</h4>, {
                entity,
                entitiesType,
              })}
            </div>
          ) : (
            <h4>{section.label}</h4>
          )}
          {Renderer && (
            <Renderer
              entity={entity}
              parent={parent}
              entitiesType={entitiesType}
              updateEntity={parent.updateEntity || parent.props.updateEntity}
              {...(section.sharedProps || {})}
            />
          )}
        </div>
      </div>
    );
  };
};

export const renderField = (...fields) => {
  const firstFieldSet = fields[0];
  const key = Array.isArray(firstFieldSet) ? firstFieldSet.reduce((prev, cur) => `${prev}-${cur[2]}`, '') : 'field';
  return (
    <div key={key} className="form-group row">
      {Array.isArray(firstFieldSet) &&
        firstFieldSet.map(([label, value, id], index) => (
          <div key={index} className="col-xs-6" id={id}>
            <label className="control-label">{label}</label>
            <div>
              <span>{value}</span>
            </div>
          </div>
        ))}
      {!Array.isArray(firstFieldSet) && (
        <div className="col-xs-12" id={fields[2]}>
          <label className={`control-label ${firstFieldSet ? '' : 'hide'}`}>{firstFieldSet}</label>
          <div>
            <span>{fields[1]}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export const renderTopSubmitBlock = (submitting, switchEditMode, value?, closePane?) => (
  <div key="top-submit-block" className="pull-right">
    <PopperTooltip placement="bottom" overlay={translate('Submit')}>
      <button
        type="submit"
        className="btn btn-sm btn-box-tool text-success"
        style={{
          padding: 0,
          lineHeight: '1.3em',
          fontSize: '15px',
        }}
      >
        <i className="lnr lnr-checkmark-circle" />
      </button>
    </PopperTooltip>
    <PopperTooltip placement="bottom" overlay={translate('Cancel')}>
      <button
        type="button"
        className="btn btn-sm btn-box-tool margin-left"
        onClick={() => (closePane ? closePane() : switchEditMode(value || '', value ? false : undefined))}
        style={{
          padding: 0,
          lineHeight: '1.3em',
          fontSize: '15px',
        }}
      >
        <i className="lnr lnr-cross-circle" />
      </button>
    </PopperTooltip>
  </div>
);

export const renderBottomSubmitBlock = (submitting, switchEditMode, value, closePane?) => (
  <div key="bottom-submit-block" className="row">
    <div className="col-xs-12">
      <div className="pull-right">
        <button type="submit" className="btn btn-sm btn-success margin-right submit" disabled={submitting}>
          {translate(submitting ? 'Submitting' : 'Submit')}
        </button>
        {!closePane && (
          <button
            type="button"
            className="btn btn-sm btn-default cancel"
            onClick={() => switchEditMode(value || '', value ? false : undefined)}
            disabled={submitting}
          >
            {translate('Cancel')}
          </button>
        )}
        {closePane && (
          <button type="button" className="btn btn-sm btn-default cancel" onClick={closePane} disabled={submitting}>
            {translate('Close')}
          </button>
        )}
      </div>
    </div>
  </div>
);

export const renderCardEditButton = (switchEditMode, value?) =>
  switchEditMode ? (
    <PopperTooltip key="card-edit-button" placement="bottom" overlay={translate('Edit')}>
      <button
        type="button"
        className="btn-box-tool btn btn-sm pull-right pencil-edit-btn"
        onClick={() => switchEditMode(value || '1', value ? true : undefined)}
        style={{
          padding: '0 5px',
          lineHeight: '1.5em',
          height: 'auto',
        }}
      >
        <i className="lnr lnr-pencil" />
      </button>
    </PopperTooltip>
  ) : null;
